import enumBase from './EnumBase';

export default class PlanIcon extends enumBase {
  static values = [
    { value: 'basic', label: 'leaf' },
    { value: 'essential', label: 'briefcase' },
    { value: 'advanced', label: 'building' },
    { value: 'corporate', label: 'rocket' },
    { value: 'postpaid', label: 'leaf' },
  ];

  static getByName(name) {
    name = name.toLowerCase();
    const item = this.values.find((i) => i.value === name);
    return item ? item.label : 'leaf';
  }
}
